
import { useState } from "react";
import projects from '../utilities/project-data';
import {Link} from "react-router-dom";
import Filter from '../components/Filter';
import React from "react";
import * as SimpleIcons from "react-icons/si";

function Projects() {
    const allFilters = ['All', ...new Set(projects.map(project => project.category))]; // create a list of all the categories of projects
    const [projectsData, setProjectsData] = useState(projects); //import projects data into an array to iterate
    const [filterButtons, setFilterButton] = useState(allFilters); // initialize an array of filter buttons to later fill
    
    const filter = (button) => {
        if(button === 'All'){
            setProjectsData(projects) //set projects data to all projects if that is was is selected
            return;
        }
        const filteredData = projects.filter(project => project.category === button);
        setProjectsData(filteredData); //setting project data to the desired filted data
    }

    return (
        <section className="projects-page">
            <h2>Portfolio Projects page</h2>
            {/* Pass filter buttons and filterfunction to be handles but the filter button creation component */}
            <Filter filters={filterButtons} filterFunction={filter}/>
            <section className="projects-container">
                {
                    //Map through the projects array and display all the appropriate data
                    projectsData.map((currentProject) => {
                        return <article className="project-card" key={currentProject.id}>
                                <div className="single-image-container">
                                    <img src={currentProject.image} alt={`${currentProject.title} Poster`} />
                                    <div className="overlay">
                                        <p className="project-description text">{currentProject.brief_description}</p>
                                    </div>
                                </div>
                            <h3 className="project-title">{currentProject.title}</h3>
                            <div className="tech-stack">
                                {/* <h3>Tech Stack:</h3> {currentProject.techStack.map((item, i) => <span key={i} value={item}>{item} </span>)} */}
                                <h3>Tech Stack:</h3> {currentProject.techStack.map((item, i) => React.createElement(SimpleIcons[`${item}`]))}
                            </div>
                            <div className="links">
                                <Link className="single-project-link grow" to={currentProject.single_link}>More Info</Link>
                                <a className="external-project-link grow" href={currentProject.external_link}>Website</a>
                            </div>
                        </article>
                    }) 
                }
            </section>
        </section>
    );
    
}

export default Projects;
